import invoices from './invoices.js'
import gifts from './gifts.js'
import returnInvoices from './returnInvoices.js'
import pricing from './pricing.js'
import saleFlowProducts from './saleFlowProducts.js'
import suggest from './suggest.js'

export default {
  menu: 'Sales',
  title: 'Sales',

  invoices,

  gifts,

  returnInvoices,

  pricing,

  saleFlowProducts,

  suggest

  /*groups: {
    title: 'Sales Groups',

    list: {
      title: 'List of sales groups'
    },

    insert: {
      title: 'Add new sales group'
    },

    edit: {
      title: 'Edit Sales Group'
    }
  }*/
}
